import { useDispatch } from 'react-redux';
import { InvoiceDownloadLink } from 'Interfaces/Billing';
import { $actions } from 'Store';

import { useAsyncAction } from '../Common';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: InvoiceDownloadLink) =>
    $actions.billing.getInvoiceDownloadLink(dispatch, payload),
  );
};
